// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Geral --- */
body {
  background-color: #ffffff;
  font-family: 'Inter', 'Roboto', sans-serif;
}

.main-title {
  font-size: 2.4rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

/* --- Barra de pesquisa --- */
.search-bar {
  width: 80%;
  max-width: 500px;
  background-color: #f3f3f3;
  border-radius: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
}

.search-bar:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.oriented-search-container {
  margin-top: 10px;
}

.oriented-search {
  color: #1976d2;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s ease;
}

.oriented-search:hover {
  color: #125ea3;
}

/* --- Resultados de pesquisa --- */
.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ddd;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  max-height: 220px;
  overflow-y: auto;
}

.search-section {
  font-weight: 600;
  padding: 8px 16px;
  background: #f7f7f7;
}

.search-item {
  padding: 10px 16px;
  transition: background-color 0.3s ease;
}

.search-item:hover {
  background-color: #f0f0f0;
}

/* --- Secções de informação --- */
.info {
  margin-top: 60px;
  text-align: center;
}

.info h2 {
  font-size: 2rem;
  color: #222;
  margin-bottom: 20px;
}

.info-list {
  padding-left: 0;
  list-style-position: inside;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
   font-weight: 500;
}

/* --- Ícones e títulos --- */
.icon-grid {
  margin-top: 20px;
}

.icon-container {
  background: #fff;
  padding: 25px 15px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.icon-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 80px !important;
  margin-bottom: 10px;
}

.lightbulb-icon {
  color: #1976d2;
}

.people-icon {
  color: #fbc02d;
}

.trending-icon {
  color: #4caf50;
}

.icon-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111;
}

.icon-description {
  font-size: 0.9rem;
  color: #555;
  margin-top: 6px;
}

/* --- Logotipos --- */
.logo-row {
  display: flex;
  justify-content: center;
  gap: 100px;
  align-items: center;
  flex-wrap: wrap;
}

.logo-img {
  max-width: 25%;
  height: auto;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.logo-img:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.search-bar .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/MainPage/mainpage.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;GACV,gBAAgB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":["/* --- Geral --- */\nbody {\n  background-color: #ffffff;\n  font-family: 'Inter', 'Roboto', sans-serif;\n}\n\n.main-title {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #222;\n  margin-bottom: 16px;\n  letter-spacing: 0.5px;\n}\n\n/* --- Barra de pesquisa --- */\n.search-bar {\n  width: 80%;\n  max-width: 500px;\n  background-color: #f3f3f3;\n  border-radius: 25px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.3s ease;\n}\n\n.search-bar:hover {\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n}\n\n.oriented-search-container {\n  margin-top: 10px;\n}\n\n.oriented-search {\n  color: #1976d2;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.oriented-search:hover {\n  color: #125ea3;\n}\n\n/* --- Resultados de pesquisa --- */\n.search-results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #ddd;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.search-section {\n  font-weight: 600;\n  padding: 8px 16px;\n  background: #f7f7f7;\n}\n\n.search-item {\n  padding: 10px 16px;\n  transition: background-color 0.3s ease;\n}\n\n.search-item:hover {\n  background-color: #f0f0f0;\n}\n\n/* --- Secções de informação --- */\n.info {\n  margin-top: 60px;\n  text-align: center;\n}\n\n.info h2 {\n  font-size: 2rem;\n  color: #222;\n  margin-bottom: 20px;\n}\n\n.info-list {\n  padding-left: 0;\n  list-style-position: inside;\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #444;\n   font-weight: 500;\n}\n\n/* --- Ícones e títulos --- */\n.icon-grid {\n  margin-top: 20px;\n}\n\n.icon-container {\n  background: #fff;\n  padding: 25px 15px;\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.icon-container:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\n}\n\n.icon {\n  font-size: 80px !important;\n  margin-bottom: 10px;\n}\n\n.lightbulb-icon {\n  color: #1976d2;\n}\n\n.people-icon {\n  color: #fbc02d;\n}\n\n.trending-icon {\n  color: #4caf50;\n}\n\n.icon-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111;\n}\n\n.icon-description {\n  font-size: 0.9rem;\n  color: #555;\n  margin-top: 6px;\n}\n\n/* --- Logotipos --- */\n.logo-row {\n  display: flex;\n  justify-content: center;\n  gap: 100px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.logo-img {\n  max-width: 25%;\n  height: auto;\n  transition: transform 0.4s ease, opacity 0.4s ease;\n}\n\n.logo-img:hover {\n  transform: scale(1.05);\n  opacity: 0.9;\n}\n.search-bar .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
